import { Divider, Input, InputOnChangeData, Toolbar, ToolbarButton } from "@fluentui/react-components";
import CloseIcon from "~icons/material-symbols/close";
import SearchIcon from "~icons/material-symbols/search";
import { debounce } from "lodash";
import { ChangeEvent, Dispatch, memo, SetStateAction, useMemo } from "react";
import { IDocument } from "../../../interfaces";
import { useDocumentReaderToolbarStyles } from "../styles/DocumentReaderToolbar.styles";
import { DocHeader } from "./DocHeader";
import { SearchNavigation } from "./SearchNavigation";

type DocumentReaderToolbarProps = {
  doc: IDocument;
  searchText: string;
  activeMark: number;
  filteredSearchLength: number;
  setSearchText: Dispatch<SetStateAction<string>>;
  setActiveMark: Dispatch<SetStateAction<number>>;
  onClose?: () => void;
};

export const DocumentReaderToolbar = memo(
  ({
    doc,
    searchText,
    activeMark,
    filteredSearchLength,
    setSearchText,
    setActiveMark,
    onClose,
  }: DocumentReaderToolbarProps) => {
    const styles = useDocumentReaderToolbarStyles();

    const onSearchTextChange = useMemo(
      () =>
        debounce((_ev: ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
          setSearchText(data.value as string);
          setActiveMark(0);
        }, 300),
      [setSearchText, setActiveMark]
    );

    return (
      <div className={styles.readerHead}>
        <Toolbar className={styles.toolbar}>
          <DocHeader doc={doc} />
          <ToolbarButton aria-label="Dismiss" icon={<CloseIcon />} appearance="subtle" onClick={() => onClose?.()} />
        </Toolbar>
        <Divider />
        <Toolbar>
          <Input
            appearance="underline"
            contentBefore={<SearchIcon />}
            contentAfter={
              <SearchNavigation
                activeMark={activeMark}
                filteredSearchLength={filteredSearchLength}
                setActiveMark={setActiveMark}
              />
            }
            onChange={onSearchTextChange}
            placeholder="Search by keywords..."
            className={styles.searchInput}
            type="text"
          />
        </Toolbar>
      </div>
    );
  }
);
